import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "@/lib/conversionTracking";

/** Sends a GA4 page_view on every client-side route change (gtag only auto-tracks the first load). */
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search + location.hash);
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default PageViewTracker;
